import type * as lazyIndex from './lazyIndex';
import { LazyAction, LazyModule } from 'owa-bundling-light';
import { serializeRejection } from './util/serializeRejection';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "DataWorker" */ './lazyIndex'),
    { name: 'DataWorker' }
);

export const lazyInitialize: LazyAction<typeof lazyIndex.initialize, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.initialize);

export const lazyExecute: LazyAction<typeof lazyIndex.execute, typeof lazyModule> = new LazyAction(
    lazyModule,
    m => m.execute
);
export const lazyUnsubscribe: LazyAction<typeof lazyIndex.unsubscribe, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.unsubscribe);
export const lazySetNotificationCallbacks: LazyAction<
    typeof lazyIndex.setNotificationCallbacks,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.setNotificationCallbacks);
export const lazyNotifySubscription: LazyAction<
    typeof lazyIndex.notifySubscription,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.notifySubscription);
export const lazyInitializeOfflineSync: LazyAction<
    typeof lazyIndex.initializeOfflineSync,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.initializeOfflineSync);
export const lazyFlushSyncLogs: LazyAction<typeof lazyIndex.flushSyncLogs, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.flushSyncLogs);
export const lazyInitializeApplicationSettings: LazyAction<
    typeof lazyIndex.initializeApplicationSettings,
    LazyModule<typeof lazyIndex>
> = new LazyAction(lazyModule, m => serializeRejection(m.initializeApplicationSettings));
export const lazyInitializeDateTime: LazyAction<
    typeof lazyIndex.initializeDateTime,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.initializeDateTime);
export const lazyInitializeFeatureFlags: LazyAction<
    typeof lazyIndex.initializeFeatureFlags,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.initializeFeatureFlags);
export const lazyInvokeWin32GqlRequestCallback: LazyAction<
    typeof lazyIndex.invokeWin32GqlRequestCallback,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.invokeWin32GqlRequestCallback);

export const lazyGetOfflineTimeZoneOffsets: LazyAction<
    typeof lazyIndex.getOfflineTimeZoneOffsets,
    LazyModule<typeof lazyIndex>
> = new LazyAction(lazyModule, m => serializeRejection(m.getOfflineTimeZoneOffsets));

export const lazyGetOfflineTimeZones: LazyAction<
    typeof lazyIndex.getOfflineTimeZones,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getOfflineTimeZones);

export const lazySaveOfflineSettings: LazyAction<
    typeof lazyIndex.saveOfflineSettings,
    LazyModule<typeof lazyIndex>
> = new LazyAction(lazyModule, m => serializeRejection(m.saveOfflineSettings));
export const lazyLoadOfflineSettings: LazyAction<
    typeof lazyIndex.loadOfflineSettings,
    LazyModule<typeof lazyIndex>
> = new LazyAction(lazyModule, m => serializeRejection(m.loadOfflineSettings));

export const lazyInvalidateOfflineConversationNodes: LazyAction<
    typeof lazyIndex.invalidateOfflineConversationNodes,
    LazyModule<typeof lazyIndex>
> = new LazyAction(lazyModule, m => serializeRejection(m.invalidateOfflineConversationNodes));

export const lazyLogPeopleDataToSyncLogs: LazyAction<
    typeof lazyIndex.logPeopleDataToSyncLogs,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.logPeopleDataToSyncLogs);

export const lazyLoadPeopleAppData: LazyAction<
    typeof lazyIndex.loadPeopleAppData,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.loadPeopleAppData);
